import { useTrackPage, removeProfileCookie } from 'utils/analytics'
import dynamic from 'next/dynamic'
import { useDatadog } from 'utils/datadog'
import { useBot } from 'hooks/useBot'
import { isEhConsentTealiumEnabled } from 'utils/consent/ehConsentTealiumEnabled'
import { EventHorizonConsentInit } from 'components/EventHorizonConsent/EventHorizonConsentInit'

const Tealium = dynamic(() => import('components/Tealium').then((mod) => mod.Tealium), {
  ssr: false,
})

function Analytics({ children, pageVariation, pageSectionsVariations, loadEventProps, siteEnv }) {
  removeProfileCookie()

  useDatadog()

  useTrackPage(pageVariation, pageSectionsVariations, loadEventProps, siteEnv)

  const { isBot } = useBot()
  const useLegacyTealiumLoader = !isEhConsentTealiumEnabled()

  return (
    <>
      {!isBot && useLegacyTealiumLoader ? <Tealium /> : null}
      <EventHorizonConsentInit />
      {children}
    </>
  )
}

export { Analytics }
